module.exports = __webpack_public_path__ + "static/media/newFeature.2aaa15e0.svg";